import { render, staticRenderFns } from "./ImsImportData.vue?vue&type=template&id=4e8e55cb&"
import script from "./ImsImportData.vue?vue&type=script&lang=js&"
export * from "./ImsImportData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports